import styled from "styled-components";

export const WalletWrapper = styled.div`
  width: 100%;
  padding: 2rem;
  padding-bottom: 10rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .card-wrapper {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .top {
    width: 100%;
  }

  .top-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
`;

export const AddFundWrapper = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .radio-wrapper {
    display: flex;
    width: 800px;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    margin-top: 10px;
  }

  .bank_details {
    margin-top: 15px;
    width: 100%;

    .li-title {
      color: ${({ theme }) => theme.text.prim_50};
      margin: 15px 5px;
    }
    li {
      color: ${({ theme }) => theme.text.prim_50};
      list-style: number;
      margin-left: 20px;
    }
  }

  button {
    margin: 20px auto;
  }
`;

export const PinWrapper = styled.div`
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;
